import { EditManagerUpdate } from '@/components/strategyDetails-page/tabs/updatesTab/editManagerUpdatePage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const EditManagerUpdatePage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Edit Manager Update</title>
      </Head>
      <EditManagerUpdate />
    </>
  );
};

export default EditManagerUpdatePage;
